module.exports = __webpack_public_path__ + "img/monmouthPark-logo-only.7cb51cfd.png";